export default __webpack_public_path__ + "static/media/ServicesUploading-ilustration.be98eeb8.png";